import { render, staticRenderFns } from "./BandwidthSms.vue?vue&type=template&id=8bf2c098&scoped=true&"
import script from "./BandwidthSms.vue?vue&type=script&lang=js&"
export * from "./BandwidthSms.vue?vue&type=script&lang=js&"
import style0 from "./BandwidthSms.vue?vue&type=style&index=0&id=8bf2c098&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf2c098",
  null
  
)

export default component.exports